<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field
          v-model="verificationCode"
          label="Verification code"
          @keydown.enter.prevent="enableMfa"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col class="text-right">
        <v-btn
          color="primary"
          :disabled="!canEnable"
          :loading="enabling"
          @click="enableMfa"
        >
          Enable MFA
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { enableMfa } from '@/utils/mfa'

export default {
  name: 'EnableMfaVerificationCode',
  props: {
    verificationId: { type: String, default: null }
  },
  emits: ['mfaEnabled', 'error'],
  data: function () {
    return {
      verificationCode: null,
      enabling: false
    }
  },
  computed: {
    canEnable() {
      return this.verificationId && this.verificationCode
    }
  },
  methods: {
    async enableMfa() {
      if (!this.canEnable) {
        return
      }
      try {
        this.enabling = true
        await enableMfa({
          verificationId: this.verificationId,
          verificationCode: this.verificationCode
        })
        this.$emit('mfaEnabled')
      } catch (error) {
        this.$emit('error', error)
      } finally {
        this.enabling = false
      }
    }
  }
}
</script>
